import { StrictMode } from 'react';
import ReactDOM from 'react-dom/client';
import { QueryClientProvider } from 'react-query';
import { Provider } from 'react-redux';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { ToastContainer } from '@cencosud-cencommerce/paris-uikit';

import { RepositoryProvider } from '@/Application/Providers/Repository';
import { URL_ROUTES } from '@/constants';
import { storeRepository } from '@/Infrastructure/MockNetwork/Store';
import { store } from '@/Infrastructure/State';
import { regionsRepository } from '@/Infrastructure/State/Slices/RegionSlice';
import { injectSigninTrackingAdapter } from '@/Infrastructure/Utils/analytics/braze/injectSigninAdapter';
import { injectSignupTrackingAdapter } from '@/Infrastructure/Utils/analytics/braze/injectSignupAdapter';
import { AddressReduxRepository } from '@/modules/address/infrastructure/AddressReduxRepository';
import { createCartPaymentsRepository } from '@/modules/cart/infrastructure/CartPaymentsRepository/CartPaymentsRepository';
import { CartReduxRepository } from '@/modules/cart/infrastructure/CartReduxRepository';
import { createCartShippingMethodsRepository } from '@/modules/cart/infrastructure/CartShippingMethodsRepository/CartShippingMethodsRepository';
import { createCustomerRepository } from '@/modules/customer/infrastructure/CustomerRepository';
import { createTokenUserIdRepository } from '@/modules/log/infraestructure/TokenUserIdRepository';
import { queryClient } from '@/modules/perseo-billing/config/query-client';
import { PickupReduxRepository } from '@/modules/pickup/infrastructure/PickupReduxRepository';
import { ShippingMethodsReduxRepository } from '@/modules/shippingMethod/infrastructure/ShippingMethodsReduxRepository';
import BuyNowLayout from '@/Pages/BuyNowLayout';
import BuyNowPage from '@/Pages/BuyNowPage';
import CustomerDataPage from '@/Pages/CustomerDataPage';
import ErrorPage from '@/Pages/ErrorPage';
import MainLayout from '@/Pages/MainLayout';
import { PerseoBillingOrderConfirmation } from '@/Pages/PerseoBillingOrderConfirmation';
import { PerseoBillingPage } from '@/Pages/PerseoBillingPage';
import ShippingPage from '@/Pages/ShippingPage';
import CustomerProvider from '@/sections/customer/CustomerContext';
import { PlaceDataProvider } from '@/sections/region/GooglePlaceDataContext';

import { createBuyNowRepository } from './modules/buy-now/infrastructure/BuyNowReduxRepository';

import '@/Styles/index.css';

//inyeccion de eventos de signup y signin
injectSignupTrackingAdapter();
injectSigninTrackingAdapter();

//sscucha cuando se termina de cargar desde el loader
window.addEventListener('braze:ready', () => {
  injectSignupTrackingAdapter();
  injectSigninTrackingAdapter();
});

const router = createBrowserRouter([
  {
    path: '/checkout/',
    errorElement: <ErrorPage />,
    element: <MainLayout />,
    children: [
      {
        index: true,
        element: <CustomerDataPage />
      },
      {
        path: URL_ROUTES.PERSONAL_DETAILS,
        element: <CustomerDataPage />
      },
      {
        path: URL_ROUTES.SHIPPING,
        element: <ShippingPage />
      },
      {
        path: URL_ROUTES.BILLING,
        element: <PerseoBillingPage />
      },
      {
        path: URL_ROUTES.BILLING_ORDER_PROCESSING_SUCCESS_PATH,
        element: <PerseoBillingOrderConfirmation />
      },
      {
        path: URL_ROUTES.BILLING_CONFIRM_ORDER_INTENT_PATH,
        element: <PerseoBillingPage />
      },
      {
        path: URL_ROUTES.WEDDING_PERSONAL_DETAILS,
        element: <CustomerDataPage />
      },
      {
        path: URL_ROUTES.WEDDING_BILLING_PATH,
        element: <PerseoBillingPage />
      },
      {
        path: URL_ROUTES.WEDDING_ORDER_PROCESSING_SUCCESS_PATH,
        element: <PerseoBillingOrderConfirmation />
      },
      {
        path: URL_ROUTES.BILLING_CONFIRM_ORDER_INTENT_PATH_WEDDING,
        element: <PerseoBillingPage />
      }
    ]
  },
  {
    path: `${URL_ROUTES.BUY_NOW}/:cartId`,
    errorElement: <ErrorPage />,
    element: <BuyNowLayout />,
    children: [
      {
        index: true,
        element: <BuyNowPage />
      }
    ]
  }
]);

const repositories = {
  regions: regionsRepository,
  addressRepository: AddressReduxRepository,
  cart: CartReduxRepository,
  stores: storeRepository,
  customerRepository: createCustomerRepository(),
  shippingMethodsRepository: ShippingMethodsReduxRepository,
  cartPaymentsRepository: createCartPaymentsRepository(),
  cartShippingMethodsRepository: createCartShippingMethodsRepository(),
  pickupRepository: PickupReduxRepository,
  tokenUserIdRepository: createTokenUserIdRepository(),
  buyNowRepository: createBuyNowRepository()
};

ReactDOM.createRoot(document.getElementById('root')!).render(
  // !deshabilitar a veces
  <StrictMode>
    <Provider store={store}>
      <RepositoryProvider repositories={repositories}>
        <QueryClientProvider client={queryClient}>
          <CustomerProvider repository={repositories.customerRepository}>
            <PlaceDataProvider>
              <ToastContainer />
              <RouterProvider router={router} />
            </PlaceDataProvider>
          </CustomerProvider>
        </QueryClientProvider>
      </RepositoryProvider>
    </Provider>
  </StrictMode>
);
